import t from '../actions/actionTypes'

const defaultState = {
	page: 0,
	order_field: 'name',
	order_type: 'asc',
	more: true,
	search: '',
	lessons: [],
	selected_lessons: [],
	show_all: false,
}

function foundLessons(state, action) {
	const newState = {...state}
	newState.page = parseInt(action.payload.page)+1
	newState.more = action.payload.more

	const newArrayElements = action.payload.entities.map(b => b.data.entityUID)

	if (action.payload.page === '0') {
		newState.lessons = newArrayElements
	} else {
		newState.lessons = [...state.lessons, ...newArrayElements]
	}

	return newState
}

function toggleSelectedLesson(state, action) {
	const newState = {...state}
	const lessonIndex = state.selected_lessons.indexOf(action.entityUID)
	if (lessonIndex === -1) {
		newState.selected_lessons = state.selected_lessons.concat([action.entityUID])
	} else {
		newState.selected_lessons = [...state.selected_lessons.slice(0, lessonIndex), ...state.selected_lessons.slice(lessonIndex+1)]
	}
	return newState

}

function updateSearchQuery(state, action) {
	const newState = {...state}
	newState.search = action.search
	return newState
}

function updateSort(state, action) {
	const newState = {...state}
	newState.page = 0
	newState.more = true
	newState.order_field = action.order_field
	newState.order_type = action.order_type
	return newState
}

const resetSearch = () => {
	const newState = {...defaultState}
	return newState
}

function toggleShowAll(state) {
	const newState = {...state}
	newState.show_all = !state.show_all
	return newState
}

function applySearchQuery(state) {
	const newState = {...state}
	newState.page = 0
	newState.more = true
	return newState
}

function cancel(state) {
	return state
}

function end() {
	const newState = {...defaultState}
	return newState
}

const bindersReducer = (state = defaultState, action) => {
	switch (action.type) {
		case t.PICKER_UPDATE_SEARCH_QUERY: return updateSearchQuery(state, action)
		case t.PICKER_UPDATE_SORT: return updateSort(state, action)
		case t.PICKER_RESET_SEARCH: return resetSearch(state, action)
		case t.BINDERS_INIT_SEARCH_BINDER_LESSONS: return resetSearch(state, action)
		case t.PICKER_TOGGLE_SHOW_ALL: return toggleShowAll(state, action)
		case t.PICKER_APPLY_SEARCH_QUERY: return applySearchQuery(state, action)
		case t.PICKER_LESSON_TOGGLE: return toggleSelectedLesson(state, action)
		case t.BINDERS_FOUND_BINDER_LESSONS:
		case t.PRIVATE_LIBRARY_FOUND_LIBRARY_LESSONS:
		case t.STOREFRONT_FOUND_LESSONS:
		case t.MY_LIBRARY_LESSONS_PICKER_SEARCH_LESSONS_FETCHED:
			return foundLessons(state, action)
		case t.BINDERS_PICKER_CANCEL:
		case t.PRIVATE_LIBRARY_LESSONS_PICKER_CANCEL:
			return cancel(state)
		case t.STOREFRONT_INIT_SEARCH_LESSONS:
		case t.PRIVATE_LIBRARY_LESSONS_PICKER_INIT:
		case t.MY_LIBRARY_LESSONS_PICKER_INIT:
			return end(state)
		default: return state
	}
}

export default bindersReducer
